// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__3nm7H","loader":"Loader_loader__VU4Qq","spin":"Loader_spin__PIF4Q"};